import axios from 'axios'
axios.defaults.withCredentials = true;

const config = require('../../config');
import { notify } from "@kyvg/vue3-notification";

const state = {
  user: null,
  users: null,
  token: null
}

const getters = {
  getUser: state => state.user,
  getUsers: state => state.users,
  getToken: state => state.token,
  isLoggedIn: state => state.user !== null
}

const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
  setToken: (state, token) => {
    localStorage.setItem('token', token);
    state.token = token;
  },
  setUsers: (state, users) => {
    state.users = users;
  },
}

const actions = {
  async getProfile ({ commit }) {
    const resp = await axios.get(`${config.baseUrl}/client/get/profile`);
    if (resp.data.result == 1){
      commit('setUser', resp.data.data);
    } else {
      commit('setUser', null);
    }
  },
  async loginUser (_, obj) {
    try {
      let query = `${config.baseUrl}/scan/login?username=${obj.username}&password=${obj.password}`;
      const resp = await axios.get(query);
      if (resp.data.result == 1){
        this.dispatch("getProfile");
      }
      return resp.data;
    } catch(e) {
      notify({
        title: "Eroare de conexiune cu serverul.",
        type: "error",
      });
      return Promise.reject(e);
    }
  },
  async deleteUser({ commit }, userId) {
    try {
      await axios.delete(`/scanner/delete?id=${userId}`);
      commit('REMOVE_USER', userId);
      return { result: 1, message: 'Utilizatorul a fost sters' };
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  },
  async logout({commit}) {
    const resp = await axios.get(`${config.baseUrl}/scan/logout`);
    if (resp.data.result == 1){
      commit('setUser', null);
    }
    return resp.data;
  },
  async addUser (_, obj) {
    let query = `${config.baseUrl}?address=/scanner/add`;
    if (obj.username != null) {
      query += `&username=${obj.username}`;
    }
    if (obj.email != null) {
      query += `&email=${obj.email}`;
    }
    if (obj.level != null) {
      query += `&level=${obj.level}`;
    }
    if (obj.password != null) {
      query += `&password=${obj.password}`
    }
    if (obj.id != null) {
      query += `&clientId=${obj.id}`
    }
    if (obj.keywords != null) {
      query += `&keywords=${obj.keywords}`
    }
    if (this.getters.getToken != null) {
      query += `&token=${this.getters.getToken}`;
    }
    const resp = await axios.post(query);
    return resp.data;
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}